import CountryStore from "../../../dashboard/stores/CountryStore";

export default {
  data () {
    return {
      publicCountries: [],
      selectedPhoneCountryCode: "961",
      selectedWorkCountryCode: "961",
      selectedBillingCountryCode: "961",
      selectedShippingCountryCode: "961"
    };
  },

  computed: {
    salutationOptions () {
      return ["Mr.", "Mrs.", "Miss"];
    },

    displayName: {
      get: function () {
        if (this.customerData.id) {
          return this.customerData.display_name;
        } else {
          return this.generateDisplayName();
        }
      },

      set: function (newValue) {
        this.customerData.display_name = newValue;
      }
    },

    customerBillingAddress () {
      return this.customerData.billing_address;
    },

    customerShippingAddress: {
      get: function () {
        return this.customerData.shipping_address;
      },

      set: function (newValue) {
        this.$set(this.customerData, "shipping_address", Object.assign({}, newValue));
      }
    }
  },

  async beforeMount () {
    this.publicCountries = await CountryStore.collection("public");
  },

  mounted () {
    this.initializeCountryCodes();
  },

  methods: {
    initializeCountryCodes () {
      this.selectedPhoneCountryCode = this.$refs.mobileInput.activeCountry.dialCode;
      this.selectedWorkCountryCode = this.$refs.workInput.activeCountry.dialCode;
      this.selectedBillingCountryCode = this.customerData.billing_address.billing_country_code || "961";
      this.selectedShippingCountryCode = this.customerData.shipping_address.shipping_country_code || "961";
    },

    onInputWorkNumber ({ country }) {
      this.selectedWorkCountryCode = country.dialCode;
    },

    onInputMobileNumber ({ country }) {
      this.selectedPhoneCountryCode = country.dialCode;
    },

    onInputBillingNumber ({ country }) {
      this.selectedBillingCountryCode = country.dialCode;
    },

    onInputShippingNumber ({ country }) {
      this.selectedShippingCountryCode = country.dialCode;
    },

    validateMobileNumber (formattedNumber, { number, valid, country }) {
      if (number.input && !valid) {
        document.getElementById("mobileInput").setCustomValidity("Please enter a valid mobile number.");
      } else {
        document.getElementById("mobileInput").setCustomValidity("");
      }
    },

    validateWorkNumber (formattedNumber, { number, valid, country }) {
      if (number.input && !valid) {
        document.getElementById("workInput").setCustomValidity("Please enter a valid mobile number.");
      } else {
        document.getElementById("workInput").setCustomValidity("");
      }
    },

    validateBillingMobileNumber (formattedNumber, { number, valid, country }) {
      if (number.input && !valid) {
        document.getElementById("billingMobileInput").setCustomValidity("Please enter a valid mobile number.");
      } else {
        document.getElementById("billingMobileInput").setCustomValidity("");
      }
    },

    validateShippingMobileNumber (formattedNumber, { number, valid, country }) {
      if (number.input && !valid) {
        document.getElementById("shippingMobileInput").setCustomValidity("Please enter a valid mobile number.");
      } else {
        document.getElementById("shippingMobileInput").setCustomValidity("");
      }
    },

    generateDisplayName () {
      if (this.customerData.account_type === "Business") {
        return this.generateCompanyDisplayName();
      } else {
        return this.generateIndividualDisplayName();
      }
    },

    generateCompanyDisplayName () {
      return this.customerData.company_name;
    },

    generateIndividualDisplayName () {
      let { salutation = "", first_name: firstName = "", last_name: lastName = "" } = this.customerData;

      return `${salutation} ${firstName} ${lastName}`.trim();
    },

    autoFillShippingAddress (e) {
      e.preventDefault();
      this.$refs.shippingMobileInput.activeCountry = this.$refs.billingMobileInput.activeCountry;
      this.selectedShippingCountryCode = this.selectedBillingCountryCode;
      this.customerShippingAddress = this.customerBillingAddress;
    }
  }
};
